
export default {
  name: "NavigationBar",

  data() {
    return {
      // showMobileMenu: false,
    };
  },

  computed: {
    currentUser() {
      return this.$store.getters["auth/currentUser"];
    },

    userDisplayName() {
      const user = this.currentUser;
      if (user?.username) {
        return user.username;
      }
      if (user?.attributes?.username) {
        return user.attributes.username;
      }
      return "User";
    },

    userEmail() {
      const user = this.currentUser;
      return user?.email || user?.attributes?.email || "";
    },

    userInitials() {
      const name = this.userDisplayName;
      if (name && name.length >= 2) {
        return name.substring(0, 2).toUpperCase();
      }
      return "U";
    },

    canAccessAdmin() {
      const user = this.currentUser;
      if (!user?.attributes?.roles) return false;
      const roles = Array.isArray(user.attributes.roles)
        ? user.attributes.roles
        : [user.attributes.roles];
      // Only Admin role can access admin modules
      return roles.some((r) => r.authority === "Admin");
    },

    isSuperAdmin() {
      const user = this.currentUser;
      if (!user?.attributes?.roles) return false;
      const roles = Array.isArray(user.attributes.roles)
        ? user.attributes.roles
        : [user.attributes.roles];
      // Check for Admin role
      return roles.some((r) => r.authority === "Admin");
    },

    userRole() {
      const user = this.currentUser;
      if (user?.attributes?.roles) {
        const roles = Array.isArray(user.attributes.roles)
          ? user.attributes.roles
          : [user.attributes.roles];
        return roles[0]?.authority || "User";
      }
      return "User";
    },
    
    // Helper to extract roles from user object
    userRoles() {
      const user = this.currentUser;
      if (!user) return [];
      
      let roles = [];
      
      if (user.attributes?.roles) {
        roles = Array.isArray(user.attributes.roles) 
          ? user.attributes.roles 
          : [user.attributes.roles];
      } else if (user.attributes?.authorities) {
        roles = Array.isArray(user.attributes.authorities) 
          ? user.attributes.authorities 
          : [user.attributes.authorities];
      } else if (user.roles) {
        roles = Array.isArray(user.roles) ? user.roles : [user.roles];
      }
      
      return roles.map(r => {
        if (typeof r === 'string') {
          return r.toUpperCase();
        } else if (r?.authority) {
          return r.authority.toUpperCase();
        } else if (r?.role) {
          return r.role.toUpperCase();
        }
        return String(r).toUpperCase();
      });
    },
    
    canMarkAttendance() {
      const roles = this.userRoles;
      return roles.some(r => 
        r === 'TEACHER' || 
        r === 'ADMIN' || 
        r === 'SYSTEM_ADMIN' ||
        r.includes('TEACHER') ||
        r.includes('ADMIN')
      );
    },
    
    isStudent() {
      const roles = this.userRoles;
      return roles.some(r => 
        r === 'STUDENT' || 
        r.includes('STUDENT')
      );
    },
  },

  methods: {
    navigateTo(path) {
      // Don't navigate if already on the same route
      if (this.$route.path === path) {
        return;
      }

      // Navigate with error handling
      this.$router.push(path).catch((err) => {
        // Ignore navigation errors (e.g., navigating to the same route)
        if (err.name !== "NavigationDuplicated") {
          console.error("Navigation error:", err);
        }
      });
    },

    isActive(path) {
      if (path === "/") {
        return this.$route.path === "/";
      }
      return this.$route.path.startsWith(path);
    },

    canAccess(resource) {
      // Only Admin role can access admin resources
      if (this.canAccessAdmin) return true;

      return false;
    },

    async logout() {
      try {
        await this.$axios.post("/logout");
      } catch (error) {
        console.error("Logout error:", error);
      } finally {
        this.$store.commit("auth/clearAuth");
        window.location.href = "/";
      }
    },
  },
};
